import { ColumnPattern } from "@/common/components/Table";

export const anpPricesByGeoTypeColumns: Record<'Geo::City' | 'Geo::State' | 'Geo::Region' | 'Geo::Country', ColumnPattern[]> = {
  'Geo::City': [
    { label: 'Município', value: 'geo', className: 'min-w-48' },
    { label: 'Produto', value: 'product', className: 'min-w-48' },
    { label: 'Preço médio (R$)', value: 'average_price', className: 'min-w-36' },
    { label: 'Mínimo (R$)', value: 'min_price', className: 'min-w-32' },
    { label: 'Máximo (R$)', value: 'max_price', className: 'min-w-32' },
  ],
  'Geo::State': [
    { label: 'Estado', value: 'geo', className: 'min-w-40' },
    { label: 'Produto', value: 'product', className: 'min-w-48' },
    { label: 'Preço médio (R$)', value: 'average_price', className: 'min-w-36' },
    { label: 'Mínimo (R$)', value: 'min_price', className: 'min-w-32' },
    { label: 'Máximo (R$)', value: 'max_price', className: 'min-w-32' },
  ],
  'Geo::Region': [
    { label: 'Região', value: 'geo', className: 'min-w-40' },
    { label: 'Produto', value: 'product', className: 'min-w-48' },
    { label: 'Preço médio (R$)', value: 'average_price', className: 'min-w-36' },
    { label: 'Mínimo (R$)', value: 'min_price', className: 'min-w-32' },
    { label: 'Máximo (R$)', value: 'max_price', className: 'min-w-32' },
  ],
  'Geo::Country': [
    { label: 'Escopo', value: 'geo', className: 'min-w-36' },
    { label: 'Produto', value: 'product', className: 'min-w-48' },
    { label: 'Preço médio (R$)', value: 'average_price', className: 'min-w-36' },
    { label: 'Mínimo (R$)', value: 'min_price', className: 'min-w-32' },
    { label: 'Máximo (R$)', value: 'max_price', className: 'min-w-32' },
  ],
};
